export enum ElectromobilityDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP',
    THIRDGROUP = 'THIRDGROUP',
}
